import request from '@/utils/request'

/**
 * 视频素材入库（接口1 · 写）
 * 后端主业务接口：POST /ai/d/video/source
 * 说明：baseURL（VUE_APP_BASE_API）已含 /api，故此处路径以 /ai/d 开头。
 * 走前端 request 实例，会自动携带用户 Bearer Token（Route A：前端中转，复用登录态）。
 *
 * 请求体即反推工作流 node19（ges_视频分析合并）输出的扁平 JSON：
 *   video_url / cover_url / duration + script_slot / shot_scale / camera_angle /
 *   camera_movement / audio_type / visual_description / tags / subject_entities /
 *   color_palette / prompt_keywords / raw_analysis
 * 后端按 video_url 去重（重复入库为更新而非新增），并校验各枚举字段取值。
 *
 * @param {object} data 合并后的素材 JSON
 * @returns {Promise<object>} 后端响应信封 { code, message, data }
 */
export function saveVideoSource(data) {
  return request({
    url: '/ai/d/video/source',
    method: 'post',
    data
  })
}

/**
 * 视频素材检索 / 初筛（接口2 · 读）
 * 后端主业务接口：POST /ai/d/video/search
 * 请求体：{ shots: [{ index, shotType, angle, cameraMove, scriptSlot, tags }], limit_per_shot }
 *   - 硬筛 4 字段：shotType→景别 / angle→机位 / cameraMove→运镜 / scriptSlot→剪辑位置
 *   - tags 可选（标签名数组）；audio_type 存主表但不参与服务端初筛
 * 响应：{ code, message, data: { shots: [{ index, candidates: [...] }] } }
 *   每条 candidate = 主表字段(video_url/cover_url/duration + 技术参数) + 详情表字段
 *   (visual_description/tags/subject_entities/color_palette/prompt_keywords)；raw_analysis 不返回
 *
 * 注：素材库浏览页不走此接口（改为读 OSS File_Overview.json）；接口2 仅用于视频拼接的按镜号匹配。
 *
 * @param {object} data { shots, limit_per_shot }
 * @returns {Promise<object>} 后端响应信封 { code, message, data }
 */
export function searchVideoSource(data) {
  return request({
    url: '/ai/d/video/search',
    method: 'post',
    data
  })
}
